import { FC } from 'react';

export type TProps = {
  src: string;
  type: string;
};

const LightboxVideo: FC<TProps> = (props) => {
  const { src, type } = props;

  return (
    <video
      controls
      className="max-w-full max-h-[calc((100svh-(var(--spacing-4)*2)-7rem))]"
    >
      <source src={src} type={type} />
      {/*Fallback to MP4 in case the original video type is not supported*/}
      {/*For example, `<source src="{...}.mov" type="video/quicktime" />` only works in Safari*/}
      {/*So `<source src="{...}.mov" type="video/mp4" />` is the fallback*/}
      <source src={src} type="video/mp4" />
    </video>
  );
};

export default LightboxVideo;
